import { useState } from 'react';

import { api, BackfillStatsResponse } from '../lib/api';

export function BackfillButton() {
  const [isBackfilling, setIsBackfilling] = useState(false);
  const [result, setResult] = useState<BackfillStatsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleBackfill = async () => {
    try {
      setIsBackfilling(true);
      setError(null);
      setResult(null);
      
      await api.backfillStats();
      
      setIsBackfilling(false);
      alert('Backfill completed successfully!');
    } catch (error: any) {
      setIsBackfilling(false);
      console.error('Backfill failed:', error);
      alert('Backfill failed. Please try again.');
    }
  };

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-medium text-yellow-800">
            🔧 Backfill Stats (Development Tool)
          </h3>
          <p className="text-sm text-yellow-700 mt-1">
            Process all unprocessed votes to populate the stats collection.
          </p>
        </div>
        <button
          onClick={handleBackfill}
          disabled={isBackfilling}
          className={`px-4 py-2 rounded-md text-white font-medium ${
            isBackfilling 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-yellow-600 hover:bg-yellow-700'
          }`}
        >
          {isBackfilling ? '⏳ Running...' : '🚀 Run Backfill'}
        </button>
      </div>

      {error && (
        <div className="bg-red-100 border border-red-300 rounded-md p-3 mb-4">
          <p className="text-red-800 text-sm">❌ Error: {error}</p>
        </div>
      )}

      {result && (
        <div className="bg-green-100 border border-green-300 rounded-md p-3">
          <h4 className="text-green-800 font-medium mb-2">✅ Results:</h4>
          <div className="text-green-700 text-sm space-y-2">
            <div>
              <h5 className="font-medium">Diagnostic:</h5>
              <ul className="ml-4 space-y-1">
                <li><strong>Total Unprocessed Votes:</strong> {result.diagnostic.totalUnprocessedVotes}</li>
                <li><strong>Total Unprocessed Comments:</strong> {result.diagnostic.totalUnprocessedComments}</li>
                <li><strong>Sites Affected:</strong> {result.diagnostic.siteIds.length}</li>
                {result.diagnostic.oldestVoteDate && (
                  <li><strong>Oldest Vote:</strong> {new Date(result.diagnostic.oldestVoteDate).toLocaleDateString()}</li>
                )}
                {result.diagnostic.newestVoteDate && (
                  <li><strong>Newest Vote:</strong> {new Date(result.diagnostic.newestVoteDate).toLocaleDateString()}</li>
                )}
              </ul>
            </div>
            <div>
              <h5 className="font-medium">Processing Results:</h5>
              <ul className="ml-4 space-y-1">
                <li><strong>Stats Documents Created:</strong> {result.processed.statsCreated}</li>
                <li><strong>Votes Processed:</strong> {result.processed.votesProcessed}</li>
                <li><strong>Comments Processed:</strong> {result.processed.commentsProcessed}</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 